import { render, staticRenderFns } from "./SetPaymentPlan.vue?vue&type=template&id=1bf88046&scoped=true"
import script from "./SetPaymentPlan.vue?vue&type=script&lang=js"
export * from "./SetPaymentPlan.vue?vue&type=script&lang=js"
import style0 from "./SetPaymentPlan.vue?vue&type=style&index=0&id=1bf88046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf88046",
  null
  
)

export default component.exports